import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'

import classnames from 'classnames'
import MailchimpSubscribe from 'react-mailchimp-subscribe'

import Alerts from '../../containers/alerts'

import { Logo, LandingFeatures } from './../icons'
import Feature1 from '../../../assets/img/campaign-feature-1.png'
import Feature2 from '../../../assets/img/campaign-feature-2.png'
import Feature3 from '../../../assets/img/campaign-feature-3.png'

const mailchimpSubscribeUrl = "https://ridline.us20.list-manage.com/subscribe/post?u=a6a2e9fc965a8546c0c4d2de1&id=e1b0cb1f24"

const CustomForm = ({ status, message, onValidated, emailSubmitted }) => {
  let email

  const submit = (e) => {
    e.preventDefault()

    email &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value
    })
  }

  return (
    <form onSubmit={submit}>
      {!emailSubmitted && <h3 className="subheading">Subscribe to never miss an update</h3>}

      {status === "sending" && <div>Sending...</div>}
      {status === "error" && (
        <div
          style={{ color: "#ea464a" }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === "success" && (
        <h3
          style={{ color: "#3adb74" }}
          className="subheading"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {!emailSubmitted && (
        <input
          ref={node => (email = node)}
          type="email"
          className="input--light"
          placeholder="Enter your email here"
        />
      )}
      {!emailSubmitted && (
        <button type="submit" className="button--success focus">
          Subscribe now
        </button>
      )}
    </form>
  )
}

class Professionals extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      emailSubmitted: false
    }
  }

  componentDidUpdate() {
    const { match } = this.props
    const { params } = match
    const { emailSubmitted } = this.state

    if (params.status === 'thank-you' && emailSubmitted !== true) this.setState({emailSubmitted: true})
  }

  render() {
    const { match } = this.props
    const { email, emailSubmitted } = this.state

    let { url } = match
    url = url.includes('for-professionals') ? '/for-professionals' : '/professionals'

    return (
      <div className="landing campaign">
        <Alerts />

        <section className="landing-header">
          <Logo />

          <div className="landing-header-cta">
            <h1 className="heading">Plan quality music events with your crew</h1>
            <h3 className="subheading">Collaboration software for the music industry</h3>

            <MailchimpSubscribe
              url={mailchimpSubscribeUrl}
              render={({ subscribe, status, message }) => (
                <CustomForm
                  status={status}
                  message={message}
                  onValidated={formData => {
                    subscribe(formData)
                    this.props.history.replace(`${url}/thank-you`)
                  }}
                  emailSubmitted={emailSubmitted} />
              )}
            />
          </div>

          <div className="landing-header-navigation">
            {/*<button className="button--inline button--link">About</button>*/}
            {/*<button className="button--inline button--link">How do we differ</button>*/}
            {/*<button className="button--inline button--primary">Visit website</button>*/}
          </div>
        </section>

        <section className="landing-features landing-about">
          <h2 className="section-title">About</h2>
          <h3 className="section-subtitle">Be Stage Ready</h3>

          <p>Ridline strives to create a transparent communication channel between every live music professional. We value teamwork and up- to- date communication in everything we do. We strive to create ways of work that are more efficient and let’s us concentrate on what’s most important. We know that the only way to make headway is to embrace modern ways of working by having transparency and efficiency in the competitive field of entertainment industry. Our goal is to make that as an everyday life for small and big crews working in live concert productions.</p>
        </section>

        <section className="landing-features landing-testimonials">
          <h2 className="section-title">Coming soon</h2>
          <h3 className="section-subtitle">Organize your production like never before</h3>

          <div className="landing-features-side">
            <ol className="landing-features-list">
              <li className="landing-features-list-item">
                <div className="landing-features-list-item-wrapper">
                  <div className="landing-features-list-item-bullet" data-value="I" />

                  <h4>Your production at the palm of your hands</h4>
                  <p>Overview your crews or artists production progress on one page. Never miss out on any details.</p>
                </div>

                <div className="landing-features-list-item-wrapper">
                  <img src={Feature1} />
                </div>
              </li>

              <li className="landing-features-list-item landing-features-list-item--reverse">
                <div className="landing-features-list-item-wrapper">
                  <div className="landing-features-list-item-bullet" data-value="II" />

                  <h4>Manage your crew and artists</h4>
                  <p>Send out information or collect files from as many people as you want, with just one click. One task to rule them all.</p>
                </div>

                <div className="landing-features-list-item-wrapper">
                  <img src={Feature2} />
                </div>
              </li>

              <li className="landing-features-list-item">
                <div className="landing-features-list-item-wrapper">
                  <div className="landing-features-list-item-bullet" data-value="III" />

                  <h4>Spread the word. Fast.</h4>
                  <p>Send information to all of your crew members and artists. If needed, send even direct messages. You choose.</p>
                </div>

                <div className="landing-features-list-item-wrapper">
                  <img src={Feature3} />
                </div>
              </li>
            </ol>
          </div>
        </section>

        <section className="landing-features landing-difference">
          <h2 className="section-title">Why are we different?</h2>

          <div className="landing-features-side">
            <ol className="landing-features-list">
              <li className="landing-features-list-item">
                <div className="landing-features-list-item-bullet" data-value="1" />

                <h5>Tailor made for the music industry</h5>
              </li>

              <li className="landing-features-list-item">
                <div className="landing-features-list-item-bullet" data-value="2" />

                <h5>Saves you from the endless production emails</h5>
              </li>

              <li className="landing-features-list-item">
                <div className="landing-features-list-item-bullet" data-value="3" />

                <h5>Collaborate stress free with your crew and members outside of it</h5>
              </li>
            </ol>
          </div>
        </section>

        <section className="landing-footer-cta">
          <LandingFeatures />

          <h2 className="section-title">Like the idea?</h2>

          <MailchimpSubscribe
            url={mailchimpSubscribeUrl}
            render={({ subscribe, status, message }) => (
              <CustomForm
                status={status}
                message={message}
                onValidated={formData => {
                  subscribe(formData)
                  this.props.history.replace(`${url}/thank-you`)
                }}
                emailSubmitted={emailSubmitted} />
            )}
          />

          <hr />
        </section>

        <section className="landing-footer">
          <span>info@ridline.com</span>
          <span>Veerenni 24, Tallinn, Estonia</span>
          <span>+372 5647 3580</span>
        </section>
      </div>
    )
  }
}

export default Professionals



// WEBPACK FOOTER //
// ./src/components/common/professionals.js